<template>
  <div class="main-header__cart__dropdown__content">
    <div class="main-header__cart__dropdown__top">
      <h5 class="main-header__cart__title--empty" v-if="!isEmpty">
        {{ "cart.title" | trans }}
      </h5>
      <span class="main-header__offcanvas__close" @click="onClose"></span>
    </div>
    <template v-if="!isEmpty">
      <div class="main-header__cart__dropdown__body">
        <ul class="main-header__cart__items">
          <li
            class="main-header__cart__item"
            v-for="item in cartItems"
            :key="item.id"
          >
            <a :href="item.product.id" class="main-header__cart__item__block">
              <img
                v-if="item.product.images && item.product.images.length > 0"
                class="main-header__cart__item__photo"
                :src="item.product.image"
                :alt="item.product.name"
              />
            </a>

            <div
              class="main-header__cart__item__content"
              @click="onProductClick(item)"
            >
              <p class="main-header__cart__item__brand">
                {{ item.product.brand.name }}
              </p>
              <p class="main-header__cart__item__name">
                {{ item.product.name }}
              </p>
              <p class="main-header__cart__item__archetype">
                {{
                  item.product.mainTaxon.name ? item.product.mainTaxon.name : ""
                }}
                {{ item.variant.name ? item.variant.name : "" }}
              </p>
              <div class="main-header__cart__item__bottom clearfix">
                <div
                  class="main-header__cart__item__prices"
                  v-if="item.discounted"
                >
                  <span
                    class="main-header__cart__item__price main-header__cart__item__price--new"
                    >{{ item.total / 100 }} Lei</span
                  >
                  <span
                    v-if="item.variant"
                    class="main-header__cart__item__price main-header__cart__item__price--old"
                  >
                    {{ "app.ui.price_recommended_by_brand" | trans
                    }}{{ item.variant.originalPrice / 100 }} Lei</span
                  >
                </div>
                <template v-else>
                  <span class="main-header__cart__item__price">
                    {{ item.total / 100 }} Lei
                  </span>
                </template>
                <p class="main-header__cart__item__quantity">
                  {{ "ui.qty" | trans }}&nbsp;{{ item.quantity }}
                </p>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="main-header__cart__bottom">
        <div class="main-header__cart__total">
          <p class="main-header__cart__total__amount">Total</p>
          <p class="main-header__cart__total__items">{{ total / 100 }} Lei</p>
        </div>
        <div class="main-header__cart__bottom__buttons">
          <div class="main-header__cart__bottom__buttons__col">
            <b-button
              :href="$websitePath('/cart')"
              variant="black"
              block
              class="main-header__cart__button"
              >{{ "cart.view_cart" | trans }}</b-button
            >
          </div>
          <div class="main-header__cart__bottom__buttons__col">
            <b-button
              :href="$websitePath('/')"
              variant="outline-black"
              block
              class="main-header__cart__button"
              >{{ "cart.place_order" | trans }}</b-button
            >
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="main-header__cart__dropdown__body empty">
        <p class="main-header__cart__empty">
          {{ "cart.empty_cart" | trans }}
        </p>
      </div>
      <div class="main-header__cart__bottom">
        <b-button
          :href="$websitePath($trans('cart.button.empty_cart_link'))"
          variant="black"
          block
          class="main-header__cart__button"
        >
          {{ "cart.button.empty_cart" | trans }}
        </b-button>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "AppCart",
  components: {},
  props: {
    items: {
      type: Array,
      required: true,
      default: () => [],
    },
    total: {
      type: Number,
      required: true,
      default: 0,
    },
  },
  computed: {
    cartItems() {
      return this.items.map(item => {
        let product = item.product || {};

        if (Array.isArray(product.images) && product.images.length) {
          product.image = `/media/cache/resolve/sylius_shop_product_thumbnail/${product.images[0].path}`;
        }
        item.product = product;
        return item;
      });
    },
    isEmpty() {
      return this.items.length === 0;
    },
  },
  methods: {
    onProductClick(item) {
      window.location = `/p/${item.product.slug}`;
    },
    onClose() {
      this.$emit("close");
    },
  },
};
</script>
